import React from "react";
export interface Props {scroll:any}
export const Section1:React.FC<Props> =({scroll})=>{

    return(
        <>
        <section className="mainSection_1" ref={(e)=>scroll.current[0]=e} >
            <div>
                <h2>main video</h2>
                <div className="video_wrap">
                    <div className="visual_video">
                        <div className="videoBG">
                            <div className="videoBG_width">
                                <div className="videoBG_aspect">
                                    <div className="videoBG_make_height">
                                        <div className="videoBG_hide_controls">
                                            <div>
                                                <iframe src="https://player.vimeo.com/video/873217112?badge=0&amp;autopause=0&amp;quality_selector=1&amp;progress_bar=1&amp;player_id=0&amp;app_id=58479?autoplay=1&loop=1&title=0&background=1" allow="autoplay; fullscreen; picture-in-picture" style={{position:'absolute',top:'0',left:'0',width:'100%',height:'100%'}}title="HYUNDAI EN-TECH_promotional_video"></iframe>
                                            </div>
                                            <script src="https://player.vimeo.com/api/player.js"></script>
                                            {/* <!-- 반응형 지원 비메오 --> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </>
    )
}